import React, { Component } from 'react';
import { Breadcrumb } from '@blueprintjs/core'
import ReactGA from 'react-ga'


class Store extends Component {
    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
    render() {
        return (
            <div>
                <ul className="pt-breadcrumbs">
                    <li><Breadcrumb href="/home" text="Home" /></li>
                    <li><Breadcrumb href="/store" text="Store" /></li>
                </ul>
                <hr />
                <div>
                    <h3>Store</h3>
                    <div>
                        <p>
                            Coming Soon!
                        </p>
                    </div>
                </div>
            </div>

        );
    }
}

export default Store;


// WEBPACK FOOTER //
// ./src/components/store/Store.jsx